
/**
 * @import external modules
 */

import * as React from "react";
import { pure } from 'recompose';



// component
const Component: React.FunctionComponent<any> = (props: InterfaceDelayedImage<any>): JSX.Element =>{

    const { items } = props;

    const onDragStart =(param: any) => (event:any) => { event.dataTransfer.setData("text/plain", param)}
 
    return(
        
        <div className="image-small" id="" draggable={true} onDragStart={onDragStart(JSON.stringify(items))}>
            <div className="image-galery">
                <img src={items && items.preprod.image_url} alt={items && items.preprod.craft}/>
            </div>
        </div>
    )
}

// interface 
export interface InterfaceDelayedImage<T>{
    items?:T
}

/**
 * DefaultProps values
 */
Component.defaultProps= {

}

export default pure(Component);


// WEBPACK FOOTER //
// ./src/apps/components/@widgets/delayed/component.tsx